import React, { useState } from 'react';
import ShareModal from './ShareModal';

const SessionShareButton = ({ sessionId, sessionName = 'Chat Session', size = 'sm', className = '', buttonText = '', disabled = false }) => {
    const [showShareModal, setShowShareModal] = useState(false);

    const handleShareClick = () => {
        if (disabled) return;
        setShowShareModal(true);
    };

    const iconSizeClass = {
        sm: 'w-5 h-5',
        md: 'w-[22px] h-[22px]',
    }[size];

    return (
        <>
            <button
                onClick={handleShareClick}
                className={`flex items-center ${className} ${
                    disabled ? 'cursor-not-allowed opacity-50' : ''
                }`}
                aria-label={disabled ? "Sharing is disabled" : "Share session"}
                disabled={disabled}
            >
                {buttonText && <span className="mr-1.5">{buttonText}</span>}
                <svg viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={iconSizeClass}>
                    <path d="M9.5 3.00017C9.77607 3.00017 9.99988 3.22413 10 3.50017C10 3.77631 9.77614 4.00017 9.5 4.00017H6C4.89551 4.00017 4.00012 4.8957 4 6.00017V14.0002C4 15.1047 4.89543 16.0002 6 16.0002H14C15.1046 16.0002 16 15.1047 16 14.0002V12.5002C16.0001 12.2241 16.2239 12.0002 16.5 12.0002C16.7761 12.0002 16.9999 12.2241 17 12.5002V14.0002C17 15.657 15.6569 17.0002 14 17.0002H6C4.34315 17.0002 3 15.657 3 14.0002V6.00017C3.00012 4.34342 4.34322 3.00017 6 3.00017H9.5ZM13.2969 2.04314C13.4771 1.96307 13.6883 1.9962 13.835 2.1281L18.835 6.6281C18.9402 6.72287 18.9999 6.85853 19 7.00017C19 7.14184 18.9402 7.27742 18.835 7.37224L13.835 11.8722C13.6883 12.0042 13.4772 12.0373 13.2969 11.9572C13.1165 11.8768 13 11.6976 13 11.5002V9.34001C11.5991 9.46822 10.3347 10.1196 9.2998 10.9484C8.28552 11.7608 7.52484 12.7163 7.10547 13.4328L6.94727 13.7238C6.84356 13.9312 6.61045 14.0398 6.38477 13.9865C6.15932 13.9331 6 13.7319 6 13.5002C6.00003 11.4519 6.38155 9.21589 7.51855 7.47673C8.60929 5.80864 10.3673 4.64331 13 4.51286V2.50017L13.0049 2.42693C13.0297 2.25945 13.1392 2.11338 13.2969 2.04314ZM14 5.00017C14 5.27631 13.7761 5.50017 13.5 5.50017C10.9125 5.50017 9.3231 6.54551 8.35645 8.02361C7.67097 9.07197 7.28309 10.3631 7.11035 11.7072C7.54278 11.1873 8.06932 10.6531 8.6748 10.1681C9.94307 9.1524 11.6004 8.3156 13.5 8.3156C13.776 8.3156 13.9998 8.53962 14 8.8156V10.3761L17.751 7.00017L14 3.62321V5.00017Z"></path>
                </svg>
            </button>

            {showShareModal && (
                <ShareModal
                    isOpen={showShareModal}
                    onClose={() => setShowShareModal(false)}
                    shareType="session"
                    targetId={sessionId}
                    defaultTitle={sessionName}
                />
            )}
        </>
    );
};

export default SessionShareButton;
